"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionsRatingGrid = void 0;
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const collection_hooks_1 = require("@hooks/collection.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const expandable_grid_1 = __importDefault(require("@shared-modules/components/expandable-grid"));
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const CollectionsRatingGrid = (props) => {
    const { filters } = props;
    const tokens = (0, tokens_reducer_1.useTokenListForCurrentChain)();
    const translator = (0, translation_hooks_1.usePagesTranslation)("ratingPage.collectionsRatingGrid");
    const { list, setPage, loaderState } = (0, collection_hooks_1.useCollectionRating)(filters.period);
    return (react_1.default.createElement(expandable_grid_1.default, { columns: (0, helper_1.getCells)(translator, tokens), data: list, minWidth: "650px", getDataId: ({ collection }) => collection.id, onPageChange: setPage, totalRows: loaderState.total || 0, pageSize: loaderState.size }));
};
exports.CollectionsRatingGrid = CollectionsRatingGrid;
